import { format, subMonths } from "date-fns";

export const generateLastNYearMonths = (count: number): YearMonthString[] => {
  if (count < 1) {
    return [];
  }

  const result: YearMonthString[] = [];
  const now = new Date();

  for (let i = count - 1; i >= 0; i -= 1) {
    const date = subMonths(now, i);
    const yearMonth = format(date, "yyyy-MM") as YearMonthString;
    result.push(yearMonth);
  }

  return result;
};
